import { Button, Spin, Table } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import moment from 'moment';
import React from 'react';
import { TitledContainer } from '../../../../components/TitledContainer/TitledContainer';
import { Confirmation } from '../../../../core-module/services/absence/types';
import { ConfirmationStatusBadge } from './ConfirmationStatusBadge';

interface Props {
  loading: boolean;
  confirmations: Confirmation[];
  onConfirm: (absencePeriodId: number, replacementId: number, accepted: boolean) => void;
}

const ReplacementOverviewComponent: React.FC<Props> = ({ loading, confirmations, onConfirm }) => {
  const columns: ColumnProps<Confirmation>[] = [
    {
      title: 'Datum',
      key: 'date',
      width: '15%',
      render: (_, item) => <span>{moment(item.date).format('dddd D MMMM YYYY')}</span>
    },
    {
      title: 'Aangevraag door',
      key: 'to',
      dataIndex: 'replacedDriverName',
      width: '25%'
    },
    {
      title: 'Status',
      key: 'status',
      width: '10%',
      render: (_, item) => <ConfirmationStatusBadge confirmationStatus={item.confirmationStatus} />
    },
    {
      title: 'Bevestigen',
      key: 'actions',
      render: (_, item) => (
        <>
          <Button
            type='primary'
            onClick={() => onConfirm(item.absencePeriodId, item.replacementId, true)}
            disabled={item.confirmationStatus !== 'Unconfirmed'}
          >
            Bevestigen
          </Button>
          <Button
            type='danger'
            style={{ marginLeft: '5px' }}
            onClick={() => onConfirm(item.absencePeriodId, item.replacementId, false)}
            disabled={item.confirmationStatus !== 'Unconfirmed'}
          >
            Afwijzen
          </Button>
        </>
      )
    }
  ];

  return (
    <TitledContainer title='Vervanging'>
      <Spin spinning={loading} delay={500}>
        <Table
          rowKey={(row, index) => index.toString()}
          dataSource={confirmations}
          locale={{ emptyText: 'U bent niet ingesteld als vervanger' }}
          bordered={true}
          pagination={false}
          columns={columns}
        />
      </Spin>
    </TitledContainer>
  );
};

export { ReplacementOverviewComponent };
